import { useRef, useState } from 'react';
import { InputRef } from 'antd';
import { Country, SORTED_COUNTRIES } from '../constants/purchase-number.constant';

type UseSelectCountryProps = {
  source: Country[];
};

export const useSelectCountry = (props?: UseSelectCountryProps) => {
  if (props == undefined) props = { source: SORTED_COUNTRIES };

  const [filteredCountries, setFilteredCountries] = useState(props?.source);
  const searchInputRef = useRef<InputRef>(null);

  const OnCountrySearchByName = (name: string) => {
    const searchedCountryName = name.toLowerCase();

    if (!searchedCountryName.trim()) {
      setFilteredCountries(props?.source);
    } else {
      setFilteredCountries(
        props?.source?.filter(
          (country) =>
            country.name.toLowerCase().includes(searchedCountryName) ||
            country.alphaTwoCode.toLowerCase().includes(searchedCountryName) ||
            country.dialingCode.toLowerCase().includes(searchedCountryName)
        )
      );
    }
  };
  const OnCountrySearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    OnCountrySearchByName(e.target.value);
  };

  return {
    filteredCountries,
    OnCountrySearch,
    OnCountrySearchByName,
    searchInputRef,
  };
};
